<template>
	<div class="container container--narrow pdt-30">
				<div v-if="lessonsList.length" class="mdc-card  mgb-24 pdb-8" >
					<div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('676')}}</div>
					<div v-for="(lesson, index) in lessonsList" :key="index" class="d-flex pdt-16 mgl-24">
						<div class="list-image-small40">
							<img v-if="lesson.contentsType.value === 'EXAM_PAPER'" class="profile" src="@/images/icon/test.svg">
							<img v-else-if="lesson.contentsType.value === 'LIVE_SESSION'" class="profile" src="@/images/icon/live_sesson.svg">
							<img v-else class="profile" src="@/images/icon/contents_icon.png">
						</div>
						<div class="flex-grow-1 pdl-20">
							<div class="mgb-16">
								<div class="t-body1 mgb-4 fff font-r pdr-24 l-spacing48">
									{{ lesson.name }}
								</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
									{{
										$t(
											lesson.contentsType.value === "SLIDE"
											? "679"
											: lesson.contentsType.value === "INTERACTIVE_HTML"
											? "3166"
											: lesson.contentsType.value === "HTML"
											? "662"
											: lesson.contentsType.value === "VIDEO"
											? "678"
											: lesson.contentsType.value === "PDF"
											? "661"
											: lesson.contentsType.value === "LIVE_SESSION"
											? "3302"
											: lesson.contentsType.value === "CEGOS"
											? "4829"
											: lesson.contentsType.translate
										)
									}}
								</div>
								<div v-if="lesson.livesessionInfo && lesson.livesessionInfo.timezone" class="mgt-3">
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
										{{lesson.livesessionInfo.timezone.text}}
									</div>
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA mgt-3" v-html="convertTimeZone(lesson.livesessionInfo.startDate,lesson.livesessionInfo.timezone.key)">
									</div>
								</div>
							</div>
							<div v-if="index < lessonsList.length-1" class="divider"></div>
						</div>
					</div>

				</div>

				<div v-if="missionsList.length"  class="mdc-card  mgb-50 pdb-8" >
					<div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{ $t('681') }}</div>
					<div v-for="(mission, index) in missionsList" :key="index" class="d-flex pdt-16 mgl-24" >
						<div class="list-image-small40">
							<img alt="" src="/img/misson.svg">
						</div>
						<div class="flex-grow-1 pdl-20">
							<div class="mgb-16">
								<div class="t-body1 mgb-3  font-r pdr-24 l-spacing48">
									{{mission.name}}
								</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                  {{ $t('682') }}
								</div>
							</div>
							<div v-if="index < missionsList.length-1" class="divider"></div>
						</div>
					</div>

				</div>

			</div>




</template>

<script>
/**
 * 차수 상세 레슨 탭 컴포넌트(degree view lesson tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'

export default {
	data() {
		return {
			lessonData: null,
			lessonsList: [],
			missionData: null,
			missionsList: [],
		}

	},

	mounted() {
		this.fetchData()
	},

	methods: {

		// 차시정보 API 호출 및 데이터 설정(call api data)
		fetchData() {
			let responseData = null
			let params = this.setParams()

			//차시 정보(lesson list)
			degreeApi.guestLearnOnlineViewCourses(params).then((response) => {
				this.lessonData = response.data.data
				// 과정의 차시 정보만 병합(Merge lesson information from the course)
				_.each(this.lessonData, (course) => {
					this.lessonsList = this.lessonsList.concat(course.lessons)
				})
			}).catch((err) => {
			})

			// 미션 정보(mission list)
			degreeApi.guestLearnOnlineViewMission(params).then((response) => {
				this.missionData = response.data.data
				if (this.missionData) {
					this.missionsList = this.missionData[0].assignments
				}
			}).catch((err) => {
			})


		},

		convertTimeZone(time,zone){
			// let convertedDateAndAMAndPM =''
			// var aestTime = new Date(time * 1000).toLocaleString("en-US", {timeZone: zone});
			// aestTime = new Date(aestTime);
			// // console.log('aestTime',aestTime)
			// // console.log('zone',zone)

			// let convertedTimeZone = aestTime.toLocaleString().replace(/\//g, '-')
			// let res = convertedTimeZone.split(",");

			// let convertedDate = this.$moment(res[0],'DD-MM-YYYY').format('YY-MM-DD')
			// let convertedTime =  this.$moment(res[1],'hh:mm:ss').format('hh:mm A')
			// let splitConvertedTime =  this.$moment(res[1],'hh:mm:ss').format('hh:mm A').split(" ")

			// return convertedDateAndAMAndPM = convertedDate && splitConvertedTime[1]=='AM'? convertedDate +' '+ splitConvertedTime[0] +' '+ this.$t('3303'): convertedDate +' '+ splitConvertedTime[0] +' '+this.$t('3304')

			let convertedTimeZone    = this.$moment.tz(time * 1000, zone);
            let splitConvertedTime = convertedTimeZone.format('YY-MM-DD hh:mm A').split(" ")
            //console.log('splitConvertedTime',splitConvertedTime)
			return this.$moment(convertedTimeZone).format('L') +' '+ this.$moment(convertedTimeZone).format('LT') ;
            // if(splitConvertedTime[2]=='AM' || splitConvertedTime[2]=='오전' || splitConvertedTime[2]=='오전에' || splitConvertedTime[2]=='오전의' || splitConvertedTime[2]=='早上' || splitConvertedTime[2]=='早晨'|| splitConvertedTime[2]=='上午'|| splitConvertedTime[2]=='晨'|| splitConvertedTime[2]=='早'|| splitConvertedTime[2]=='朝') {
            //     return this.$t('3303',{'str1':`${splitConvertedTime[0]}`,'str2':`${splitConvertedTime[1]}`})
            // }

            // if(splitConvertedTime[2]=='PM' || splitConvertedTime[2]=='오후' || splitConvertedTime[2]=='저녁' || splitConvertedTime[2]=='저녁때' || splitConvertedTime[2]=='下午') {
            //     return this.$t('3304',{'str1':`${splitConvertedTime[0]}`,'str2':`${splitConvertedTime[1]}`})
            // }
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				degreeId: this.$route.params.degreeId
			}
			return params
		},
	}
}
</script>
